import { makePaginatedSearch } from "api/makeApiRequestType/makePaginatedSearch";
import { formatDataForGetRequest } from "api/utils/formatDataForGetRequest";
import { ValidationCallback } from "validation/validate";

export type OutputRow = {
	id: string;
	sessionDescription: string;
	sessionTitle: string;
	isEnabled: boolean;
	series: string;
};

type Params = {
	uid: string;
	showDisabled?: boolean;
};

export const flagValidationErrorsInRow: ValidationCallback<OutputRow> = (
	input,
	{ flag, checkField }
) => {
	checkField("id", { type: "string" });
	checkField("sessionDescription", { type: "string" });
	checkField("sessionTitle", { type: "string" });
	checkField("isEnabled", { type: "boolean" });
	checkField("series", { type: "string" });
};

export const getSessionTypes = makePaginatedSearch<Params, OutputRow>({
	endPoint: "sessionTypes",
	flagValidationErrorsInRow,
	preProcessor: input => formatDataForGetRequest(input, false)
});
